import React from "react";
import "./Terms.css";

const Terms = () => {
  return (
    <div className="terms-wrap">
      <h1 className="terms-title">Terms &amp; Conditions</h1>

      <ol className="terms-list">
        <li>To successfully enrol in the course, students must pay the fee in full.</li>
        <li>Fees once paid are non-refundable.</li>
        <li>Fees once paid are non-transferable.</li>
        <li>Students are expected to attend all classes and be on time for every session.</li>
        <li>Students who do not maintain at least 90% attendance will not be eligible to receive a certificate of completion.</li>
        <li>If a student plans to be absent, he/she must inform the teacher in advance.</li>
        <li>Missed classes will not be repeated individually.</li>
        <li>If a class is not conducted due to a holiday or the teacher’s absence, a compensatory session will be arranged.</li>
        <li>
          If a student feels unable to attend the batch they enrolled in, they may request to reschedule, provided there is a valid/genuine reason:
          <ul className="terms-sublist">
            <li>The request must be made at least 1 week before the start date of the batch.</li>
            <li>The new batch must be chosen within 3 months from the start date of the originally selected batch.</li>
            <li>The reschedule option can be used only once per enrolment.</li>
            <li>The management’s decision will be final on all rescheduling requests.</li>
          </ul>
        </li>
        <li>Students must maintain respectful behaviour during classes. Disruptive conduct may result in removal from the course without refund.</li>
        <li>Study materials provided are strictly for the personal use of the student and must not be shared or copied.</li>
        <li>
          Since courses are conducted online, students must ensure a stable internet connection, proper setup, and use appropriate devices
          (computer or mobile, headset, speaker, microphone, etc.).
        </li>
        <li>
          All sessions will be on video call. Students are expected to attend from a room with good lighting and minimal disturbance. Cameras
          must remain switched on for the entire duration of the class.
        </li>
        <li>
          Recording of sessions by any means is strictly prohibited. Legal action may be initiated if anyone is found recording the proceedings
          of the class.
        </li>
        <li>
          Certificates will be issued only to students who successfully complete the course. NewZeal reserves the right to make the final decision
          on this matter.
        </li>
        <li>
          NewZeal reserves the right to make reasonable changes to the schedule, duration, class format, or terms, with or without prior notice, if
          required for reasons beyond its control or in the best interest of students and teachers.
        </li>
      </ol>
    </div>
  );
};

export default Terms;
